<num-date-picker [selectedDate]="selectedDate" (dateChanged)="setSelectedDate($event)">
</num-date-picker>
